<template>
  <div class="spinner-dialog" v-if="type === 'indeterminate'" :data-message="dataMessage">
    <div class="progress">
        <div class="indeterminate"></div>
    </div>
  </div>
</template>
<script>
export default {
  name:'ProgressBar',
  props:{
    dataMessage:{
      type: String,
      default:'Loading Please Wait...'
    },
    type:{
      type: String,
      default:'indeterminate'
    }
  }
}
</script>
<style scoped lang="scss">

.spinner-dialog {
  width: 60%;
  max-width: 320px;
  position: fixed;
  left:50%;
  top:50%;
  transform: translate(-50%, -50%);
  margin: auto;
  z-index: 99999;
  &::after{
    content:attr(data-message);
    bottom: -10px;
    position: absolute;
    font-size: 12px;
  }
}
.progress {
  background-color: rgba(0, 0, 0, 0.15);
/* 
  .indeterminate {
    background-color: var(--data-primary);
  } */
}
</style>